// import FileLoaderService from "platform/viewer/src/routes/Local/fileLoaderService";

const isImportant = tags => {

  var fs = parseFloat(tags.MagneticFieldStrength);

  if (!isNaN(fs) && fs >= 1.5) {
    if (tags.ImageType[0] === 'ORIGINAL') {
      if (tags.ScanningSequence) {
        if (tags.ScanningSequence.includes('SE') || tags.ScanningSequence.includes('RM') || tags.ScanningSequence.includes('IR')) {
          if (!tags.ScanningSequence.includes('EP')) {
            return true;
          }
          else {
            // console.log('EP !!!!', tags.ScanningSequence);
            return 'scanning sequence: EP';
          }
        }
        else {
          return 'scanning sequence not SE / RM / IR';
        }
      }
      else {
        console.log('no scanningSequence tag in instance');
        return 'no scanningSequence';
      }
    }
    else {
      return 'images are not ORIGINAL';
    }
  }
  else {
    return 'low field strength';
  }
};

export default isImportant;
